import React from 'react'
import { BodyContainer } from '../../containers/BodyContainer'
import { Cilindros } from './Cilindro'
import { Estacionario } from './Estacionario'

import { Typography } from '@mui/material'
import { PageContainer } from '../../containers'
import  CarouselImages  from './CarouselImages'
import { Products } from './Products'
import { useOpenComponent } from '../../../hooks/useOpenComponent'
import {  CustomModal } from '../../modals'
import { AppContext } from '../../../context'
import { OnGoingService } from './OnGoingService'
import { Navbar } from '../../../navbar/Navbar'
import { Header } from '../../header'
import { AddressSaved } from '../address'
import { Account } from '../account/Account'
import { PreviewOrder } from '../preview-order'
import { Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux'


export const Dashboard = () => {
  const { isOpen, handleIsOpen } = useOpenComponent()
  const user = useSelector(state => state.login)
  
  return (
    <AppContext.Provider value={{
      isOpen, handleIsOpen
    }}>
    <PageContainer alignItems="start">
      <Header />
      <Navbar />
      <Outlet />
    </PageContainer>
    </AppContext.Provider>
  )
}
